if (!customElements.get('shildn-video-modal')) {
  customElements.define(
    'shildn-video-modal',
    class ShildnVideoModal extends ModalDialog {
      constructor() {
        super();
      }

      show(opener) {
        super.show(opener);
        const media = this.querySelector('deferred-media');
        if (media) media.loadContent();
      }
    }
  );
}
